const items = [
  "Maldives Overwater Villas",
  "Swiss Alps by Rail",
  "Rajasthan Palaces",
  "Bali Jungle Retreats",
  "Fast-Track Schengen Visa",
  "Dubai Skyline Nights",
  "Kerala Backwaters",
  "Parisian Evenings",
  "Japan in Bloom",
  "Kashmir Valleys",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-gold/20 bg-surface/70 py-5"
  >
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {items.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="font-display italic text-xl sm:text-2xl text-cream/85 px-6">{item}</span>
              <span className="text-gold text-sm">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
